module.exports = __webpack_public_path__ + "static/media/banner_ssr_ticket827fef5324cc85e778974c0f1515a9fb.webp";